// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedProducts_root__2JDQE","title":"RelatedProducts_title__1ZShv"};